/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState, useRef, useEffect } from "react";
import { cn } from "tailwind-variants";
import initProductSavedCartsSelector from "components/jiffy/product-saved-carts-selector/product-saved-carts-selector";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import TransfersStoreCredit from "./common/TransfersStoreCredit.vue";
import Spinner from "components/jiffy/react-cart/Spinner.vue";
import Artwork from "./Artwork.vue";
import Summary from "./Summary.vue";
import UploadBox from "./UploadBox.vue";
import DtfAddToCart from "./DtfAddToCart.vue";
import DeliveryDate from "./DeliveryDate.vue";
import PreCut from "./PreCut.vue";
import DesignServicesSubscribe from "./ArtworkQualityConfigPanel/DesignServices/DesignServicesSubscribe.vue";
import { useDtfStore } from "./store";
import "./MultiArtworkModal.scss";
import { renderList } from "common/vue/render-list";

function MultiArtworkModal({
  moveBellow = false,
  currentStore = null,
  activeConfigSection = "jiffy-print-perfect",
  onUpload,
  slots,
  ...restProps
}: any) {
  // @ts-expect-error TS(6133): 'setPreventClose' is declared but its value is nev... Remove this comment to see the full error message
  const [preventClose, setPreventClose] = useState(true);
  const [isSameDay, setIsSameDay] = useState(false);
  const deliveryDateObserverRef = useRef(null);
  const modalRef = useRef(null);

  const dtfStore = useDtfStore();

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.showModal;
  }

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return dtfStore.artworks;
  }

  function files() {
    // @ts-expect-error TS(4111): Property 'files' comes from an index signature, so... Remove this comment to see the full error message
    return dtfStore.files;
  }

  function loadedArtworks() {
    // @ts-expect-error TS(4111): Property 'loadedArtworks' comes from an index sign... Remove this comment to see the full error message
    return dtfStore.loadedArtworks;
  }

  function withPreCut() {
    // @ts-expect-error TS(4111): Property 'withPreCut' comes from an index signatur... Remove this comment to see the full error message
    return dtfStore.withPreCut;
  }

  function isSticker() {
    // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.isSticker;
  }

  function isGuest() {
    // @ts-expect-error TS(4111): Property 'isGuest' comes from an index signature, ... Remove this comment to see the full error message
    return dtfStore.isGuest;
  }

  function storeCreditInfo() {
    // @ts-expect-error TS(4111): Property 'storeCreditInfo' comes from an index sig... Remove this comment to see the full error message
    return dtfStore.storeCreditInfo;
  }

  function blankItemsCount() {
    // @ts-expect-error TS(4111): Property 'blankItemsCount' comes from an index sig... Remove this comment to see the full error message
    return dtfStore.blankItemsCount;
  }

  function isBogoApplicable() {
    // @ts-expect-error TS(4111): Property 'isBogoApplicable' comes from an index si... Remove this comment to see the full error message
    return dtfStore.isBogoApplicable;
  }

  function isNewToTransfers() {
    // @ts-expect-error TS(4111): Property 'isNewToTransfers' comes from an index si... Remove this comment to see the full error message
    return dtfStore.isNewToTransfers;
  }

  function uploadedCount() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return loadedArtworks().length + 1;
  }

  function pendingFiles() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return files().filter(({ uploadError }: any) => !uploadError);
  }

  function filesUploadedMessage() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (pendingFiles().length === files().length) {
      return "All files successfully uploaded";
    }
    return "Files have been uploaded";
  }

  function showStoreCredit() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return !isSticker() && !isGuest() && Number(storeCreditInfo().orderSubtotal) > 0;
  }

  function showFreeTransfersBadge() {
    if (!isBogoApplicable()) {
      return false;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const allArtworksReady = artworks().every(
      (artwork: any) => !artwork.isLoading && !artwork.isFile
    );
    if (!allArtworksReady) {
      return false;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (blankItemsCount() <= 0) {
      return false;
    }
    if (isGuest()) {
      return true;
    }
    if (isNewToTransfers() === null || isNewToTransfers() === undefined) {
      return false;
    }
    return isNewToTransfers() === true;
  }

  function getModal() {
    return modalRef.current;
  }

  function getDeliveryDateTarget() {
    const modal = getModal();
    // @ts-expect-error TS(2339): Property 'querySelector' does not exist on type 'n... Remove this comment to see the full error message
    return modal?.querySelector(".js-product-details-delivery-dates-simple-direct-value");
  }

  function getDeliveryDateText() {
    const target = getDeliveryDateTarget();
    return target ? target.textContent.trim().toLowerCase() : "";
  }

  function updateIsSameDay() {
    const dateText = getDeliveryDateText();
    const sameDayValue = dateText.includes("today");
    setIsSameDay(sameDayValue);
  }

  function setupDeliveryDateObserver() {
    const target = getDeliveryDateTarget();
    if (target) {
      updateIsSameDay();
      const observer = new MutationObserver(() => updateIsSameDay());
      observer.observe(target, {
        childList: true,
        subtree: true
      });
      // @ts-expect-error TS(2322): Type 'MutationObserver' is not assignable to type ... Remove this comment to see the full error message
      deliveryDateObserverRef.current = observer;
    }
  }

  function setShowDiscardModal(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setShowDiscardModal(...args);
  }

  function updatePdpDates(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updatePdpDates(...args);
  }

  function onShow() {
    // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
    const $modal = $(getModal());
    $modal
      .modal("show")
      .on("hide.bs.modal", (event: any) => {
        if (showModal() && preventClose && event.target.id === $modal[0].id) {
          event.preventDefault();
          onClose();
        }
      })
      .on("hidden.bs.modal", () => {
        $modal.off("hidden.bs.modal");
        document.body.classList.remove("dtf-modal-open");
      });
    document.body.classList.add("dtf-modal-open");
  }

  function onClose() {
    setShowDiscardModal();
  }

  function handleUpload() {
    onUpload?.();
  }

  useEffect(() => {
    onShow();
    setupDeliveryDateObserver();
    queueMicrotask(() => {
      // @ts-expect-error TS(2339): Property 'JiffyDeliverTo' does not exist on type '... Remove this comment to see the full error message
      window.JiffyDeliverTo.reloadToggle();
    });
    initProductSavedCartsSelector(true);
    updatePdpDates();

    return () => {
      // @ts-expect-error TS(2339): Property 'disconnect' does not exist on type 'neve... Remove this comment to see the full error message
      deliveryDateObserverRef.current?.disconnect();
      // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
      const $modal = $(getModal());
      $modal.off("hide.bs.modal hidden.bs.modal");
      $modal.modal("dispose");
      document.querySelector(".modal-backdrop:last-of-type")?.remove();
      if (!document.querySelector(".modal.show")) {
        document.body.classList.remove("modal-open", "dtf-modal-open");
      }
    };
  }, []);

  const { className: inheritedClassName, ...otherProps } = restProps;

  return (
    <div
      {...otherProps}
      className={cn(
        "modal multi-artwork-modal scope-fd566941",
        moveBellow && "multi-artwork-modal--bellow",
        inheritedClassName
      )}
      id="multi-artwork-modal"
      ref={modalRef}
      role="dialog"
      data-testid="modal"
    >
      <div className="multi-artwork-modal__modal-box modal-dialog scope-fd566941">
        <div
          className="multi-artwork-modal__modal-header scope-fd566941"
          role="heading"
          aria-label="Your files"
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
          tabIndex="0"
          data-testid="multi-artwork-modal-modal-header"
        >
          <h3 className="multi-artwork-modal__modal-title scope-fd566941">
            {pendingFiles().length ? (
              <>
                <Spinner
                  className="multi-artwork-modal__top-icon scope-fd566941"
                  size="small"
                  data-testid="multi-artwork-modal-top-icon"
                />{" "}
                {/* @ts-expect-error TS(2571): Object is of type 'unknown'. */}
                Uploading {uploadedCount()} of {artworks().length} files{" "}
              </>
            ) : (
              <>
                <div className="scope-fd566941">
                  <UseSvg
                    className="multi-artwork-modal__top-icon scope-fd566941"
                    icon="check-circle"
                    data-testid="multi-artwork-modal-top-icon-1"
                  />
                </div>{" "}
                {filesUploadedMessage()}
              </>
            )}
          </h3>
          <button
            className="multi-artwork-modal__modal-button-close scope-fd566941"
            type="button"
            onClick={onClose}
            data-testid="multi-artwork-modal-modal-button-close"
          >
            <UseSvg className="scope-fd566941" icon="modal-close-big" data-testid="use-svg" />
          </button>
        </div>
        <div className="multi-artwork-modal__modal-body scope-fd566941">
          <div className="multi-artwork-modal__artworks scope-fd566941">
            {renderList(artworks(), (item, index) => (
              <Artwork
                className="scope-fd566941"
                key={index + String(item.id)}
                defaultActiveConfigSection={index === 0 ? activeConfigSection : undefined}
                artwork={item}
                index={index}
                isLoading={item.isLoading}
                currentStore={currentStore}
                isMultiUpload={true}
                showFreeTransfersBadge={showFreeTransfersBadge()}
                showFullScreenButton={true}
                data-testid="artwork"
              />
            ))}
            {/* @ts-expect-error TS(2571): Object is of type 'unknown'. */}
            {!files().length ? (
              <UploadBox
                className="scope-fd566941"
                onUpload={handleUpload}
                data-testid="upload-box"
              />
            ) : null}
          </div>
          <div className="multi-artwork-modal__summary scope-fd566941">
            <div className="multi-artwork-modal__delivery-date scope-fd566941">
              <DeliveryDate
                className="scope-fd566941"
                isSameDay={isSameDay}
                data-testid="delivery-date"
              />
            </div>
            {slots?.["free-shipping"]?.()}
            {withPreCut() ? (
              <PreCut className="scope-fd566941" isModal={true} data-testid="pre-cut" />
            ) : null}
            <DesignServicesSubscribe
              className="scope-fd566941"
              data-testid="design-services-subscribe"
            />

            <Summary className="scope-fd566941" data-testid="summary" />
            {showStoreCredit() ? (
              <TransfersStoreCredit
                className="scope-fd566941"
                storeCreditInfo={storeCreditInfo()}
                data-testid="transfers-store-credit"
              />
            ) : null}
            {slots?.["saved-carts"]?.()}
            <DtfAddToCart className="scope-fd566941" data-testid="dtf-add-to-cart" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiArtworkModal;
